import type { DummyFoods } from './dummyFoods'

export const organMeat: DummyFoods = {
  'Organ meat': {
    Liver: {
      Beef: {
        Cooked: ['Beef liver (cooked)'],
        Raw: ['Beef liver (raw)'],
      },
      Chicken: {
        Cooked: ['Chicken liver (cooked)'],
        Raw: ['Chicken liver (raw)'],
      },
    },
  },
}
